import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpParams,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loader: LoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
        // Check if loading should be disabled based on request parameters

    let disableLoading = request.params.get('disabledLoading');
    if (!disableLoading) {
      this.loader.show(); // Show the loader when not disabled
    }
    //return next.handle(request).pipe(finalize(()=>{this.loader.hide()}));
    // Return the HTTP request and add an interceptor to hide the loader on response
    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          this.loader.hide(); // Hide the loader on successful HTTP response
        }
        return event;
      })
    );
  }
}
